import { Pipe, PipeTransform } from '@angular/core';
import {Booking} from '../model/booking.entity';
import * as momentTimeZone from 'moment-timezone';

@Pipe({
  name: 'timeShort'
})
export class ShortTimePipe implements PipeTransform {

  transform(timeVal: any, state?: any, postCode?: any): any {
    let res = '';
    if (timeVal && state && postCode) {
      let timeZone = Booking.getNamedTimeZone(state, postCode.toString());
      return momentTimeZone(timeVal).tz(timeZone).format('hh:mm A');
    }
    return res.length ? res : timeVal ? timeVal : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/short-time.pipe.ts